import React from 'react';
import {greyishBlue600} from "assets/jss/main";

function SubtitleSeparator(props) {
    return (
        <div style={{
            width: '2px',
            height: '2px',
            borderRadius: '999px',
            background: greyishBlue600,
            margin: '8px'
        }}></div>
    );
}

export default SubtitleSeparator;
